export default __webpack_public_path__ + "static/media/08.db78c209.jpg";